import { BasePill } from "./BasePill";
import { PillProps } from "./types";

export const PrimaryPill = ({
  children,
  variant = "DEFAULT",
  ...props
}: PillProps) => {
  return (
    <BasePill {...props} type="PRIMARY" variant={variant}>
      {children}
    </BasePill>
  );
};
